import { NavLink } from 'react-router-dom';
import { 
    faCommentsDollar,
    faFileInvoice,
    faMoneyBillTransfer,
    faMoneyCheckDollar,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigation } from 'hooks';
import styles from './NavBar.module.scss';

export default function NavBar() {
    const { deductionsUrl, disputesUrl, invoicesUrl, paymentsUrl } = useNavigation();

    return (
        <div className={styles.navBarContainer}> 
            <div className={styles.navBarLinksContainer}>
                <div className={styles.navBarLink}>
                    <FontAwesomeIcon className={styles.icon} icon={faMoneyCheckDollar} />
                    <NavLink className={styles.link} to={paymentsUrl}>                     
                        Payments
                    </NavLink>
                </div>
                <span className={styles.navBarSeparator}>|</span>
                <div className={styles.navBarLink}>
                    <FontAwesomeIcon className={styles.icon} icon={faFileInvoice} />
                    <NavLink className={styles.link} to={invoicesUrl}> 
                        Invoices
                    </NavLink>
                </div>
                <span className={styles.navBarSeparator}>|</span>
                <div className={styles.navBarLink}>
                    <FontAwesomeIcon className={styles.icon} icon={faMoneyBillTransfer} />
                    <NavLink className={styles.link} to={deductionsUrl}> 
                        Deductions
                    </NavLink>
                </div>
                <span className={styles.navBarSeparator}>|</span>
                <div className={styles.navBarLink}>
                    <FontAwesomeIcon className={styles.icon} icon={faCommentsDollar} />
                    <NavLink className={styles.link} to={disputesUrl}> 
                        Disputes
                    </NavLink> 
                </div>   
            </div>   
        </div>
    );
};